import axios from "axios";
import api from "../api/api";

export const MANUAL_TYPE = {
  G: "g",
  KT: "kt",
};

export const PLATFORM_TYPE = {
  LEGACY: "legacy",
  KCP: "kcp",
  NONE: "",
};

export const getManualApiBasePath = (manualType, platformType) => {
  if (!manualType) return "";
  if (manualType === MANUAL_TYPE.G && platformType === PLATFORM_TYPE.KCP) {
    return `${manualType}/${PLATFORM_TYPE.KCP}`;
  }
  return manualType;
};

export const resolveManualTypeFromPathname = (pathname) => {
  if (pathname === "/g/kcp" || pathname.startsWith("/g/kcp/")) {
    return { manualType: MANUAL_TYPE.G, platformType: PLATFORM_TYPE.KCP };
  }
  if (pathname === "/g" || pathname.startsWith("/g/")) {
    return { manualType: MANUAL_TYPE.G, platformType: PLATFORM_TYPE.LEGACY };
  }
  if (pathname === "/kt" || pathname.startsWith("/kt/")) {
    return { manualType: MANUAL_TYPE.KT, platformType: PLATFORM_TYPE.NONE };
  }
  return { manualType: "", platformType: "" };
};

const getRoutePrefix = (manualType, platformType) => {
  if (manualType === MANUAL_TYPE.G && platformType === PLATFORM_TYPE.KCP) {
    return `/g/kcp`;
  }
  return `/${manualType}`;
};

export const buildManualPagePath = (manualType, platformType, url) => {
  if (!url) return null;

  const trimmed = url.trim();
  const routePrefix = getRoutePrefix(manualType, platformType);

  if (trimmed.startsWith("/g/kcp/")) return trimmed;
  if (trimmed.startsWith("/g/") && platformType !== PLATFORM_TYPE.KCP) {
    return trimmed;
  }
  if (trimmed.startsWith("/kt/")) return trimmed;

  const normalizedUrl = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return `${routePrefix}${normalizedUrl}`;
};

/** 라우트 loader의 redirect()용 상대 경로 (예: /g/foo → foo) */
export const toRouteRelativePath = (absolutePath, manualType, platformType) => {
  if (!absolutePath) return null;
  const prefix = `${getRoutePrefix(manualType, platformType)}/`;
  if (absolutePath.startsWith(prefix)) {
    return absolutePath.slice(prefix.length);
  }
  if (absolutePath === getRoutePrefix(manualType, platformType)) {
    return "";
  }
  return absolutePath.replace(/^\//, "");
};

export const fetchRepresentManualPath = async (manualType, platformType) => {
  const basePath = getManualApiBasePath(manualType, platformType);
  try {
    const res = await axios.get(
      `/api/${basePath}/${api.manual.represent.substring(5)}`,
    );
    return buildManualPagePath(manualType, platformType, res.data?.url);
  } catch {
    return null;
  }
};
